<template>
	<v-dialog v-model="dialog" :return-value.sync="date" persistent width="fit-content">
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="picker.date"
				outlined
				:class="picker.class"
				dense
				:label="picker.label"
				:error-messages="picker.errorMessage"
				append-icon="mdi-calendar"
				readonly
				v-bind="attrs"
				v-on="on"
				:hide-details="picker.hideDetail"
				:disabled="disable"
				@click:append="dialog = true"
				:color="picker.color ? picker.color : $store.state.PointColor1"
			></v-text-field>
		</template>

		<v-date-picker
			v-model="picker.date"
			:multiple="picker.multiple"
			:range="picker.range"
			:allowed-dates="allowed_dates"
			:type="picker.type"
			no-title
			scrollable
			@input="$emit('input'), (dialog = false)"
			@change="$emit('change')"
			:color="picker.color ? picker.color : $store.state.PointColor1"
			:day-format="foramtDay"
			locale="ko-kr"
		>
			<v-spacer></v-spacer>
			<v-btn text color="PointColor2" @click="dialog = false">
				Cancel
			</v-btn>
		</v-date-picker>
	</v-dialog>
</template>

<script>
export default {
	props: {
		picker: Object,
		disable: Boolean,
		allowed_dates: Function,
		// disabledata: Function,
	},
	data() {
		return {
			date: new Date().toISOString().substr(0, 10),
			dialog: false,
			off: 0,
		}
	},
	methods: {
		foramtDay(value) {
			if (value.substr(8, 1) === '0') {
				return value.substr(9, 1)
			} else {
				return value.substr(8, 2)
			}
		},
	},
}
</script>

<style lang="scss">
.whiteBack {
	background-color: white;
}
.samplePicker {
	background-color: white;
}
.defalut-date-picker-setting {
	max-width: 120px !important;
	width: 120px !important;
	.v-input__slot {
		min-height: 26px !important;
		height: 26px !important;
		padding: 0 2px !important;
		font-size: 90%;
	}
	.v-text-field__slot input {
		max-height: 26px !important;
		padding: 6px 0 2px 5px !important;
	}
	.v-input__append-inner {
		margin-top: 2px !important;
	}
	.v-icon {
		color: #ffae28 !important;
		font-size: 16px;
	}
}
</style>
